/*
    {
        vowel: "",
        aSeriesIpa: "",
        oSeriesIpa: "",
        aSeries: "",
        oSeries: "",
    }, 
*/
export const vowels = [
  {
    vowel: 'ា',
    aSeriesIpa: '[aː]',
    oSeriesIpa: '[iːə]',
    aSeries: 'a',
    oSeries: 'ea',
  },
  {
    vowel: 'ិ',
    aSeriesIpa: '[ə]',
    oSeriesIpa: '[ɨ]',
    aSeries: 'e',
    oSeries: 'i',
  },
  {
    vowel: 'ី',
    aSeriesIpa: '[əj]',
    oSeriesIpa: '[iː]',
    aSeries: 'ei',
    oSeries: 'i',
  },
  {
    vowel: 'ឹ',
    aSeriesIpa: '[ə]',
    oSeriesIpa: '[ɨ]',
    aSeries: 'oe',
    oSeries: 'ue',
  },
  {
    vowel: 'ឺ',
    aSeriesIpa: '[əɨ]',
    oSeriesIpa: '[ɨː]',
    aSeries: 'eu',
    oSeries: 'ueu',
  },
  {
    vowel: 'ុ',
    aSeriesIpa: '[o]',
    oSeriesIpa: '[u]',
    aSeries: 'o',
    oSeries: 'u',
  },
  {
    vowel: 'ូ',
    aSeriesIpa: '[ou]',
    oSeriesIpa: '[uː]',
    aSeries: 'ou',
    oSeries: 'u',
  },
  {
    vowel: 'ួ',
    aSeriesIpa: '[uə]',
    oSeriesIpa: '[uə]',
    aSeries: 'uo',
    oSeries: 'uo',
  },
  {
    vowel: 'ើ',
    aSeriesIpa: '[aə]',
    oSeriesIpa: '[əː]',
    aSeries: 'aeu',
    oSeries: 'eu',
  },
  {
    vowel: 'ឿ',
    aSeriesIpa: '[ɨə]',
    oSeriesIpa: '[ɨə]',
    aSeries: 'oea',
    oSeries: 'oea',
  },
  {
    vowel: 'ៀ',
    aSeriesIpa: '[iə]',
    oSeriesIpa: '[iə]',
    aSeries: 'ie',
    oSeries: 'ie',
  },
  {
    vowel: 'េ',
    aSeriesIpa: '[ei]',
    oSeriesIpa: '[eː]',
    aSeries: 'e',
    oSeries: 'e',
  },
  {
    vowel: 'ែ',
    aSeriesIpa: '[ae]',
    oSeriesIpa: '[ɛː]',
    aSeries: 'ae',
    oSeries: 'eae',
  },
  {
    vowel: 'ៃ',
    aSeriesIpa: '[aj]',
    oSeriesIpa: '[ɨj]',
    aSeries: 'ai',
    oSeries: 'ey',
  },
  {
    vowel: 'ោ',
    aSeriesIpa: '[ao]',
    oSeriesIpa: '[oː]',
    aSeries: 'ao',
    oSeries: 'ou',
  },
  {
    vowel: 'ៅ',
    aSeriesIpa: '[aw]',
    oSeriesIpa: '[ɨw]',
    aSeries: 'au',
    oSeries: 'ov',
  },
]
